import memoize from 'memoize-one';
import { sessionDatesParser } from 'utils/objectDatesParser.js';
import storageAvailable from './storageAvailable.lib.js';

function canStore() {
  return memoize(storageAvailable)('sessionStorage');
}

export function getItem(key) {
  if (!canStore()) {
    return undefined;
  }
  const str = sessionStorage.getItem(key);
  return str && sessionDatesParser(JSON.parse(str));
}

export function setItem(key, value) {
  if (!canStore()) {
    return;
  }
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function removeItem(key) {
  if (!canStore()) {
    return;
  }
  sessionStorage.removeItem(key);
}

export function getKeys(re) {
  if (!canStore()) {
    return undefined;
  }
  const nKeys = sessionStorage.length;
  const result = [];
  for (let i = 0; i < nKeys; ++i) {
    const key = sessionStorage.key(i);
    if (!re || re.test(key)) {
      result.push(key);
    }
  }
  return result;
}
